"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isAdExemptStory = function (story) {
    return !!(story === null || story === void 0 ? void 0 : story.isAdExempt);
};
exports.default = isAdExemptStory;
